// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"0b287df3","907":"13bce076"}[chunkId] + ".chunk.js";
};